export const WALMART_SHIPPER_ID = 1489
export const MAX_MINUTES = 300
export const APPROVED_STATE = 'approved'
export const REJECTED_STATE = 'rejected'
export const PENDING_STATE = 'pending'

export interface IDialogType {
  title: string
  message: string
  state: string
  label: string
}

export const APPROVAL_DIALOG = {
  title: 'Approval Confirmation',
  message: 'Are you sure you want to approve this',
  state: APPROVED_STATE,
  label: 'Approve',
}
export const REJECTION_DIALOG = {
  title: 'Rejection Confirmation',
  message: 'Are you sure you want to reject this',
  state: REJECTED_STATE,
  label: 'Reject',
}

const REJECTION_REASONS = [
  'Was late to appointment',
  'Did not consistently track via mobile app for a tracking required shipment',
  'Missing information',
  'Shipment did not meet detention requirements',
  'Detention request submitted after 24 hours',
  'Duplicate Request',
  'Not a detention request',
  'Layover begins after 5 hours',
]

export enum REJECTION_REASON {
  late = 'Was late to appointment',
  didNotTrack = 'Did not consistently track via mobile app for a tracking required shipment',
  missingInfo = 'Missing information',
  lackedRequirements = 'Shipment did not meet detention requirements',
  lateRequest = 'Detention request submitted after 24 hours',
  duplicate = 'Duplicate Request',
  invalidRequest = 'Not a detention request',
  layover = 'Layover begins after 5 hours',
}

export const MAP_REJECTION_REASONS = REJECTION_REASONS.map((reason: string) => ({
  value: reason,
  label: reason,
}))

export const EXPIRATION_DAYS = 3
